<template>
    <div id="app">
    <v-app id="inspire">
        <v-layout v-if="mechanicsQueue">
            <v-container fill-height grid-list-md class="pt-0">
                <v-layout row wrap>
                    <v-card-text class="display-2 font-weight-black text-xs-center pt-1 pb-1">{{branch}}</v-card-text>

                    <v-flex xs6 v-for="list in mechanicsQueue" :key="list.transactionId" v-if="mechanicsQueue.length > 1">
                        <v-card elevation="1" outlined tile>
                        <v-card-text class="display-1 font-weight-regular text-xs-center">Mechanic: {{list.mechanic}}</v-card-text>
                        <v-divider></v-divider>
                        <v-card-text class="display-2 font-weight-regular text-xs-center">Serving</v-card-text>
                        <div>
                            <v-container>
                                <v-card-text class="display-4 font-weight-black text-xs-center pt-0">{{list.motorcycle.model}}</v-card-text>
                                <v-card-text class="display-4 font-weight-black text-xs-center pt-0">{{list.motorcycle.plateNumber}}</v-card-text>
                            </v-container>
                        </div>
                        </v-card>
                    </v-flex>

                    <v-flex v-for="list in mechanicsQueue" :key="list.transactionId" v-else xs12>
                        <v-card-text class="display-3 font-weight-regular text-xs-center pt-5 pb-0">Serving</v-card-text>
                        <div>
                            <v-container>
                                <v-card-text class="display-4 font-weight-black text-xs-center pt-0">{{list.motorcycle.model}}</v-card-text>
                                <v-card-text class="display-4 font-weight-black text-xs-center pt-0">{{list.motorcycle.plateNumber}}</v-card-text>
                            </v-container>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
        
        <v-flex v-else>
            <div class="display-2 font-weight-black">Book for Motorcycle Service Online</div>
        </v-flex>

        <v-footer dark height="auto">
            <v-card-text class="indigo lighten-1 white--text text-xs-center">
            <strong class="display-1 font-weight-black">service-scheduler.transcycle.com.ph</strong>
            </v-card-text>
        </v-footer>
    </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions, mapState  } from "vuex"
import moment from 'moment'
import _ from 'lodash'
export default {
    data() {
        return {
            branchId: "",
            branch: "",
            branchCode: "",
            transactions: [],
            mechanics: [],
            mechanicsQueue: [],
            date: moment().utcOffset('+0800').toISOString().substr(0, 10),
            formatedDate:new Date().toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'}),
        }
    },

    mounted() {
        let self = this
        self.fetchBranch()
    },

    methods: {
        fetchBranch() {
            let self = this
            let branch = ""
            firebase.auth().onAuthStateChanged(function(user) {
                db.collection("Users"+self.$stage).doc(user.uid)
                .onSnapshot(function(doc) {
                    branch = doc.data().assign
                    self.branchId = doc.data().assignId
                    self.branchCode = branch.split('_')[0].trim()
                    self.branch = branch.split('_')[1].trim()
                    if(self.branch != "") {
                        self.fetchTransactions()
                        self.fetchMechanics()
                    }
                })
            })
        },

        fetchMechanics() {
            let self = this
            db.collection("Mechanics"+self.$stage)
            .where("branchId", "==", self.branchId)
            // .where("branchCode", "==", self.branchCode)
            .where("status", "==", "Active")
                .onSnapshot(function(querySnapshot) {
                    self.mechanics = []
                    querySnapshot.forEach(function(doc) {
                        self.mechanics.push(doc.id)
                    })
                })    
        },

        pivotMechanicTransactions() { 
            let self = this
            let count = 0
            self.mechanicsQueue = []
            setTimeout(() => {
                let result = _(self.transactions)
                .groupBy('mechanic')
                .map((item, key) => ({
                    mechanic: key,
                    transactionId: _.map(item, 'transactionId'),
                    motorcycle: _.map(item, 'motorcycleDetails'),
                }))
                .value()

                result.forEach(function(res){
                    let object = ""
                    for(let i = 0; i < res.transactionId.length; i++){
                        object = res.transactionId[i]
                    }

                    let motorcycle = ""
                    for(let i = 0; i < res.motorcycle.length; i++){
                        motorcycle = res.motorcycle[i]
                    }
                    count ++
                    self.mechanicsQueue.push({
                        mechanic: res.mechanic,
                        transactionId: object,
                        motorcycle: motorcycle
                    })
                })
            }, 1000)
        },

        fetchTransactions() {
            let self = this
            db.collection("ServiceBooking"+self.$stage)
            .where("branchId", "==", self.branchId)
            // .where("branchCode", "==", self.branchCode)
            .where("appointmentDate", "==", self.date)
            .where("status", "==", "Waiting")
            .where("serving", "==", "1")
                .onSnapshot(function(querySnapshot) {
                    let list = []
                    querySnapshot.forEach(function(doc) {
                        list.push(doc.data())
                    })
                    self.transactions = _.uniqWith(list, _.isEqual) 
                    self.pivotMechanicTransactions()
                })
        },
    },

    computed: {
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },
}
</script>
